export default __webpack_public_path__ + "static/media/mainLogo.641d2b6d.svg";